import { render, staticRenderFns } from "./FlexCarousel.vue?vue&type=template&id=0266b278&"
import script from "./FlexCarousel.vue?vue&type=script&lang=js&"
export * from "./FlexCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports